const state = () => {
  return {
    menu: [
      {
        icon: "ActivityIcon",
        pageName: "transaction",
        title: "거래"
      },
      {
        icon: "Corner-Right-DownIcon",
        pageName: "take-in",
        title: "매입"
      },
      {
        icon: "Corner-Right-UpIcon",
        pageName: "take-out",
        title: "매출"
      },
      {
        icon: "Dollar-SignIcon",
        pageName: "hand-amount",
        title: "시재금"
      }
    ]
  };
};

// getters
const getters = {
  menu: state => state.menu
};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
